module.exports = __webpack_public_path__ + "img/arrow-down.5f178c1d.svg";